import { render, staticRenderFns } from "./TypesTableMobile.vue?vue&type=template&id=74d78c80&scoped=true&"
import script from "./TypesTableMobile.vue?vue&type=script&lang=js&"
export * from "./TypesTableMobile.vue?vue&type=script&lang=js&"
import style0 from "./TypesTableMobile.vue?vue&type=style&index=0&id=74d78c80&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74d78c80",
  null
  
)

export default component.exports